import Vue from 'vue';
import store from '@/store';
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";
import MovimentacaoRequest from "@/models/cliente/movimentacao-request";
import ReguaHistoricoResponse from "@/models/regua-historico-response";
import SyncModel from "@/models/cliente/sync.model";

class MovimentacaoService {

    STATUS_OK: number = 200;

    async mover(body: MovimentacaoRequest): Promise<any> {
        return await Vue.prototype.$axios.post(`regua-cobranca/mover-massa`, body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS,
                        'Movimentação realizada com sucesso!');
                    return true;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR,
                        'Falha inesperada no fluxo de movimentação');
                    return false;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR,
                    'Falha inesperada no fluxo de movimentação');
                console.error(error.response);
                return false;
            });
    }

    async getHistorico(numDocumento: any): Promise<any> {
        return await Vue.prototype.$axios.get(`regua-cobranca/${numDocumento}/history`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const lista: Array<ReguaHistoricoResponse> = response.data.historico_posicoes;
                    if (lista.length === 0) {
                        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Nenhuma nota encontrada');
                    }
                    return lista;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao carregar notas');
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async sync(): Promise<any> {
        return await Vue.prototype.$axios.post('regua-cobranca/sync_initialize')
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const retorno: SyncModel = response.data;
                    return retorno;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

}

export default new MovimentacaoService();
